import { render, staticRenderFns } from "./ApplicantFormStep1.vue?vue&type=template&id=5e3521b7&scoped=true"
import script from "./ApplicantFormStep1.vue?vue&type=script&lang=js"
export * from "./ApplicantFormStep1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e3521b7",
  null
  
)

export default component.exports